import Model, { attr, hasMany } from '@ember-data/model';
import type { ModelRegistry } from 'ember-data/types/registries/model';

export default abstract class AbstractBulkClosedModel extends Model {
  @attr('boolean') sunday!: boolean;
  @attr('boolean') monday!: boolean;
  @attr('boolean') tuesday!: boolean;
  @attr('boolean') wednesday!: boolean;
  @attr('boolean') thursday!: boolean;
  @attr('boolean') friday!: boolean;
  @attr('boolean') saturday!: boolean;

  @attr('date') from!: Date;
  @attr('date') to!: Date;

  @hasMany('property', { inverse: null, async: false })
  properties!: ModelRegistry['property'][];
}
